<app-page-title [title]="'Update Score Recipients'"></app-page-title>
<div *ngIf="regInfo && testScoresOption">
    <div class="row">
        <div class="col-md-12 bg-policy">
            <p>
                Your {{brandName}} Official Score Report can be downloaded as a PDF once the scores are posted. You can submit your PDF Official Score Report directly to your academic institution or professional organization. 
                <br />
                By selecting a new score recipient, you give the institution access to your scores for verification purposes. These institutions can be updated at any time within the score validity period.
            </p>
        </div>
    </div>
    <br />
    <form
        [formGroup]="userForm"
        name="order-score-report-form"
    >
        <div class="form-container">
            <div class="row">
                <div class="col-md-5">
                    <div class="form-group">
                        <label>Test Date</label>
                        <input
                            type="text"
                            class="form-control"
                            readonly="readonly"
                            formControlName="formattedTestDateTime"
                            name="formattedTestDateTime"
                        />
                    </div>
                    <div class="form-group">
                        <label>Registration Number</label>
                        <input
                            type="text"
                            class="form-control"
                            readonly="readonly"
                            formControlName="publicRegIdentifier"
                            name="publicRegIdentifier"
                        />
                    </div>
                </div>

                <div class="col-md-7">
                    <div class="form-group">
                        <label>Test Centre</label>
                        <input
                            type="text"
                            class="form-control"
                            readonly="readonly"
                            formControlName="testCentreName"
                            name="testCentreName"
                        />
                    </div>
                    <div class="form-group">
                        <label>Location</label>
                        <textarea
                            class="form-control"
                            readonly="readonly"
                            formControlName="testCentreLocation"
                            name="testCentreLocation"
                            rows="5"
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <app-score-report-options-selector
        [testTypeId]="testTypeId"
        [isWebDelivery]="isWebDelivery"
        [storeTestScoresOption]="testScoresOption"
        [regInfo]="regInfo"
        [showIRCCOnNewInstitutions]="showIrccOnNewInstitutions"
        [regId]="regId"
    ></app-score-report-options-selector>
    <br />
    <div class="row">
        <div class="col-md-12 bottomButtons">
            <a
                [routerLink]="['/my-account']"
                class="btn btn-primary m-2"
            >Back</a>
            <button
                [disabled]="!optionSelector?.shipmentPreferenceUpdated && !optionSelector?.scoreRecipientsUpdated"
                name="confirmationYesBtn"
                type="submit"
                class="btn btn-primary m-2"
                (click)="saveChanges()"
            >Save Changes</button>
            <a
                *ngIf="isAddedToCart"
                [routerLink]="['/shopping-cart']"
                class="btn btn-primary m-2"
            >Go to Shopping Cart</a>
        </div>
    </div>
    <br />
</div>
